import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, LogManager } from 'aurelia-framework';
import { Logger } from 'aurelia-logging';
import { RouterEvent } from 'aurelia-router';
import { DialogHelper } from 'framework/aurelia_dialogs/dialog-helper';
import { ErrorHandler } from './error-handler';

@autoinject
export class AureliaHandler extends ErrorHandler {
  protected logger: Logger;

  constructor(private eventAggregator: EventAggregator, private dialogHelper: DialogHelper) {
    super();
    this.logger = LogManager.getLogger('ErrorHandler');
  }

  handleRouterEvents(): this {
    this.eventAggregator.subscribe(RouterEvent.Error, event => this.processError(event.result.output));
    return this;
  }

  logError(error) {
    this.logger.error(error.message || 'Error', error);
  }

  standardConfiguration(): this {
    return super
      .standardConfiguration()
      .handleRouterEvents();
  }
}
